import DataTable from "./DataTable.vue";

export default DataTable;